import IndentsList from '@/modules/indents/index';
import RfqList from '@/modules/indents/views/bidsList';
import DocumentDetails from '@/modules/indents/views/documentDetails';
import HistoricIndentsList from '../indents/historiIndentList';
import FirstInAllotmentList from '@/modules/indents/views/firstInAllotmentList';
import IndentRepublishRequests from '@/modules/indents/views/indentRepublishRequests';

const indents = [
  {
    path: '/indents',
    name: 'IndentsList',
    component: IndentsList,
    meta: {
      title: 'Indents',
    },
  },
  {
    path: '/indents/:orderNo',
    name: 'DocumentDetails',
    component: DocumentDetails,
    meta: {
      title: 'Indents',
      requiresAuth: true,
    },
  },
  {
    path: '/rfq',
    name: 'RfqList',
    component: RfqList,
    meta: {
      title: 'Indents RFQ',
    },
  },
  {
    path: '/historicIndents',
    name: 'HistoricIndentsList',
    component: HistoricIndentsList,
    meta: {
      title: 'Historic Indents',
    },
  },
  {
    path: '/firstInAllotments',
    name: 'FirstInAllotmentList',
    component: FirstInAllotmentList,
    meta: {
      title: 'First In Allotment Indents',
    },
  },
  {
    path: '/indentRequests',
    name: 'IndentRepublishRequests',
    component: IndentRepublishRequests,
    meta: {
      title: 'Indent Requests',
    },
  },
];

export default indents;
